// extracted by mini-css-extract-plugin
export default {"root":"AdminReportingTable_root__eMQcf","property-select":"AdminReportingTable_property-select__j80gH","action-cell":"AdminReportingTable_action-cell__c-kfj"};